import { motion } from "framer-motion";

interface TestimonialCardProps {
  quote: string;
  author: string;
  role?: string;
  variant?: "light" | "dark";
}

const TestimonialCard = ({ quote, author, role, variant = "light" }: TestimonialCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className={`p-6 md:p-8 rounded-lg ${
        variant === "light" 
          ? "bg-white shadow-md" 
          : "bg-secondary/10"
      }`}
    >
      <blockquote className="text-lg md:text-xl font-playfair italic text-secondary/90 mb-4">
        "{quote}"
      </blockquote>
      <div className="text-secondary">
        <p className="font-medium">{author}</p>
        {role && <p className="text-sm text-secondary/60">{role}</p>}
      </div>
    </motion.div>
  );
};

export default TestimonialCard;
